import { render, staticRenderFns } from "./certs.vue?vue&type=template&id=178e55ce&"
import script from "./certs.vue?vue&type=script&lang=js&"
export * from "./certs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports